import Swiper, { Navigation, Pagination } from 'swiper';

class Video {
    init() {
        this.initCarousel();
        this.initBindEvents();
    }

    initBindEvents() {
        let videoModalTrigger = document.querySelectorAll('.js-video-modal');
        let videoModalClose = document.querySelectorAll('.js-video-modal-close');

        videoModalTrigger.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();

                let videoSrc = trigger.getAttribute('data-src');
                let videoTitle = trigger.getAttribute('data-title');
                let videoModal = document.getElementById('videoModal');
                let videoIframe = document.getElementById('videoIframe');
                let videoLoading = document.querySelector('.js-video-loading');

                videoLoading.classList.remove('hide');
                videoIframe.src = videoSrc;
                videoIframe.title = videoTitle;
                videoModal.classList.add('active');
            });
        });

        videoModalClose.forEach((close) => {
            close.addEventListener('click', (event) => {
                event.preventDefault();
                let videoModal = document.getElementById('videoModal');
                let videoIframe = document.getElementById('videoIframe');
                let videoLoading = document.querySelector('.js-video-loading');

                videoLoading.classList.add('hide');
                videoIframe.src = '';
                videoModal.classList.remove('active');
            });
        });
    }

    initCarousel() {
        let carousels = document.querySelectorAll('.video-carousel');

        if (carousels !== null) {
            carousels.forEach((carousel, index) => {
                let carouselId = carousel.getAttribute('data-carousel-id');
                let itemCount = carousel.querySelectorAll('.video-carousel-item');
                let slidesPerViewCount = 3;

                if (itemCount.length <= 2) {
                    slidesPerViewCount = 2;
                }

                const swiper = new Swiper(`.video-swiper-${carouselId}`, {
                    breakpoints: {
                        992: {
                            slidesPerView: slidesPerViewCount,
                            slidesPerGroup: 3,
                            spaceBetween: 20,
                        }
                    },
                    navigation: {
                        nextEl: `.video-swiper-button-next-${carouselId}`,
                        prevEl: `.video-swiper-button-prev-${carouselId}`,
                    },
                    modules: [Navigation, Pagination],
                    pagination: {
                        clickable: true,
                        el: `.video-swiper-pagination-${carouselId}`,
                    },
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                    centerInsufficientSlides: true
                });
            });
        }
    }
}

export default Video;

(() => {
    const video = new Video();
    video.init();
})();